import { map, isEmpty } from 'lodash';

let showMembershipPrices;
let updateMembershipPrice;
const membershipEndpoint = '/ajax/membership';

(function ($) {

  function getIds(films) {
    if (!isEmpty(films)) {
      return map(films, 'nid');
    }
  }

  showMembershipPrices = function () {
    var films = [];
    var id = 0;
    $.each($('[data-search="rentals-text-label"]'), function (id, value) {
      if ($(this).data('avail') == 'avail') {
        id = $(this).data('filmId');
        films.push({ 'nid': id });
      }
    });

    if (films.length > 0) {
      $.ajax(membershipEndpoint, {
        method: 'GET',
        contentType: "application/json",
        data: { ids: getIds(films).join('|') }
      }).done(function (data) {

        $.each(data, function (id, message) {
          var label = $('[data-search="rentals-text-label"]').filter('[data-film-id="' + id + '"]');
          var price = $('[data-search="rentals-text-label"][data-film-id="' + id + '"]')
            .closest('[data-component-id="nuplayer:film_card"]')
            .find('p[data-component-id="nuplayer:details"]')
            .filter(function () {
              return $(this).text().trim().startsWith('£');
            });

          // If film is available
          if (typeof label.attr('data-ent') == 'undefined' || label.attr('data-ent') == '') {
            price.html(message['film_card_price']);
          }
        });
      });
    }
  };

  updateMembershipPrice = function () {
    $.ajax(membershipEndpoint, {
      method: 'GET',
      contentType: "application/json",
      data: { ids: $('#play-film').data('filmId') }
    }).done(function (data) {

      $.each(data, function (id, message) {
        console.log($);
        if (!$.isEmptyObject(message)) {
          var label = $('#play-film');
          var price = $('[data-search="rentals-text-label"][data-film-id="' + id + '"]')
            .closest('[data-component-id="nuplayer:film_card"]')
            .find('p[data-component-id="nuplayer:details"]')
            .filter(function () {
              return $(this).text().trim().startsWith('£');
            });

          // If film is available
          if (typeof label.attr('data-ent') == 'undefined' || label.attr('data-ent') == '') {
            label.find('span').html(message['price']);
            price.html(message['film_card_price']);
          }
        }
      });
    });
  };

})(jQuery);

const fetchMembershipPrice = async function (filmId) {
  try {
    const response = await fetch(`${membershipEndpoint}?ids=${filmId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching membership price:', error);
    throw error;
  }
};

const landingInit = function (pillar) {
  if (pillar === 'rental') {
    showMembershipPrices();
  }
}

const pageInit = function (pillar) {
  if (pillar === 'rental') {
    updateMembershipPrice();
    showMembershipPrices();
  }
}

export default {
  landingInit,
  pageInit,
  fetchMembershipPrice,
}
